/*
 * @Author: “zhangjiahao04”
 * @Date: 2023-08-23 15:50:14
 * @LastEditors: caiqin.xie
 * @LastEditTime: 2023-09-13 18:23:10
 * @FilePath: \pico-ow2c-fe\src\pages\outer\about\index.tsx
 * @Description: ‘关于我们’ 主页面
 * @url:www.picoxr.com/cn/about
 */
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import styles from "./index.module.scss";
import brandConcept from "./assets/brand_concept.png";
import ourStories from "./assets/our_stories.png";
import valueMission from "./assets/value_mission.png";
import brandLogo from "./assets/brand_logo.png";
import ImageGallery from "./components/ImageGallery";
import Timeline from "./components/TimerShaft";
import request from "@/common/request";
import {
  DOMAIN_API,
  ABOUTUSPOS,
  COUNTRY_LIST,
  COUNTRY_HREFLANG,
  AWARDTYPE,
  MEDIATYPE
} from "@/common/const";

import Banner from "./components/Banner";
import Awards from "./components/Awards";
import MoreExting from "./components/MoreExting";
import Media from "./components/Media";

const _ = require("lodash");

const About = (props: any) => {
  const { ctry, words } = props.data;
  const { aboutUsProductVoList, awards, banners, media } = props.data.data;
  const [scrollTop, setScrollTop] = useState(0) // 滚动条距离顶部的高度

  // 监听滚动事件
  useEffect(() => {
    window.addEventListener('scroll', () => scrollEvent())
    return window.removeEventListener('scroll', () => scrollEvent())
  }, [])

  /** 滚动事件 */
  const scrollEvent = _.throttle((): void => {
    setScrollTop(document.documentElement.scrollTop)
  }, 20)
  // const scrollEvent = (): void => {
  //   setScrollTop(document.documentElement.scrollTop)
  // }

  return (
    <>
      <Helmet>
        <title>{words?.about_us_seo_title}</title>
        <meta name="description" content={words?.about_us_seo_description} />
        <meta name="keywords" content={words?.about_us_seo_keywords} />
        <link rel="canonical" href={`${DOMAIN_API}/${ctry}/about`} />
        {COUNTRY_LIST.map((item) => (
          <link
            key={item}
            rel="alternate"
            hrefLang={COUNTRY_HREFLANG[item]}
            href={`${DOMAIN_API}/${item}/about`}
          />
        ))}
      </Helmet>
      <Header ctry={ctry} words={words} />
      <main className={styles["about-warp"]}>
        {/* 头部banner */}
        <Banner banners={banners} />

        {/* 四张动效图片 */}
        <ImageGallery
          scrollTop={scrollTop}
          imageUrl={brandConcept}
          title={words?.about_us_dynamic_effect_title1}
          desc={words?.about_us_dynamic_effect_desc1}
        />
        <ImageGallery
          scrollTop={scrollTop}
          imageUrl={ourStories}
          title={words?.about_us_dynamic_effect_title2}
          desc={words?.about_us_dynamic_effect_desc2}
        />
        <ImageGallery
          scrollTop={scrollTop}
          imageUrl={valueMission}
          title={words?.about_us_dynamic_effect_title3}
          desc={words?.about_us_dynamic_effect_desc3}
        />
        <ImageGallery
          scrollTop={scrollTop}
          imageUrl={brandLogo}
          title={words?.about_us_dynamic_effect_title4}
          desc={words?.about_us_dynamic_effect_desc4}
        />

        {/* 获奖 */}
        <Awards words={words} awards={awards} />

        {/* 媒体 */}
        <Media media={media} words={words} />

        {/* More Exciting */}
        <MoreExting words={words} ctry={ctry} />

        {/* 产品里程碑 */}
        <Timeline aboutUsProductVoList={aboutUsProductVoList} words={words} />

        {/* <div className={styles["join-us-warp" ]}>
          <h2 className={styles["title" ]}>Join us</h2>
          <span className={styles["content" ]}>PICO is committed to becoming a leading world-class XR platform, achieving developers and creators, and working together.</span>
          <div className={styles["learn-more" ]}>learn-more <IconRight /></div>
        </div> */}
      </main>
      <Footer />
    </>
  );
};

function getInit(ctry: string) {
  return new Promise((resolve, reject) => {
    request
      .post(`${DOMAIN_API}/o/aboutUs/selectDetail`, {
        bannerPositionId: ABOUTUSPOS,
        awardsId: AWARDTYPE,
        mediaId: MEDIATYPE,
        stationCode: ctry,
        page: 1,
        awardsRows: 20,
        mediaRows: 10,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

About.getInitialProps = (ctry: string) => {
  return getInit(ctry);
};
export default About;
